/**
 * Shared Typography Configuration
 * 
 * This file contains all typography-related values that are consistent
 * across light and dark themes. Import this configuration into theme
 * files to ensure unified typography changes.
 */

export const sharedTypography = {
    // Legacy font configuration (kept for backward compatibility)
    fontFamilies: {
        main: 'Gilroy',
        title: 'Gilroy',
    },
    fontSizes: {
        main: '14px',
        title: '33px',
        subheader: '12px',
    },
    fontWeights: {
        main: '600',
        title: '800',
        subheader: '400',
    },
    lineHeights: {},
    breakpoints: {},
    
    // Modern typography system
    typography: {
        fontFamily: {
            primary: 'IBM Plex Sans',
        },
        sizes: {
            0: '12px',    // 12px (was xs)
            1: '14px',    // 14px (was sm)
            2: '16px',    // 16px (was base)
            3: '24px',    // 24px (was lg)
            4: '28px'     // 28px (was xl)
        },
        weights: {
            normal: 400,
            medium: 500,
            bold: 700
        },
        lineHeight: {
            zeroPx: 1,
            onePx: '18px',
            twoPx: '24px',
            threePx: 1,
            fourPx: 1,
        },
        // Typography utility functions that return CSS strings
        variants: {
            // 12px variants (size 0)
            '0_normal': (theme) => `
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.sizes[0]};
                font-weight: ${theme.typography.weights.normal};
                line-height: ${theme.typography.lineHeight.zeroPx};
            `,
            '0_medium': (theme) => `
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.sizes[0]};
                font-weight: ${theme.typography.weights.medium};
                line-height: ${theme.typography.lineHeight.zeroPx};
            `,
            '0_bold': (theme) => `
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.sizes[0]};
                font-weight: ${theme.typography.weights.bold};
                line-height: ${theme.typography.lineHeight.zeroPx};
            `,
            // 14px variants (size 1)
            '1_normal': (theme) => `
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.sizes[1]};
                font-weight: ${theme.typography.weights.normal};
                line-height: ${theme.typography.lineHeight.onePx};
            `,
            '1_medium': (theme) => `
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.sizes[1]};
                font-weight: ${theme.typography.weights.medium};
                line-height: ${theme.typography.lineHeight.onePx};
            `,
            '1_bold': (theme) => `
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.sizes[1]};
                font-weight: ${theme.typography.weights.bold};
                line-height: ${theme.typography.lineHeight.onePx};
            `,
            // 16px variants (size 2)
            '2_normal': (theme) => `
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.sizes[2]};
                font-weight: ${theme.typography.weights.normal};
                line-height: ${theme.typography.lineHeight.twoPx};
            `,
            '2_medium': (theme) => `
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.sizes[2]};
                font-weight: ${theme.typography.weights.medium};
                line-height: ${theme.typography.lineHeight.twoPx};
            `,
            '2_bold': (theme) => `
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.sizes[2]};
                font-weight: ${theme.typography.weights.bold};
                line-height: ${theme.typography.lineHeight.twoPx};
            `,
            // 24px variants (size 3)
            '3_normal': (theme) => `
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.sizes[3]};
                font-weight: ${theme.typography.weights.normal};
                line-height: ${theme.typography.lineHeight.threePx};
            `,
            '3_medium': (theme) => `
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.sizes[3]};
                font-weight: ${theme.typography.weights.medium};
                line-height: ${theme.typography.lineHeight.threePx};
            `,
            '3_bold': (theme) => `
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.sizes[3]};
                font-weight: ${theme.typography.weights.bold};
                line-height: ${theme.typography.lineHeight.threePx};
            `,
            // 28px variants (size 4)
            '4_normal': (theme) => `
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.sizes[4]};
                font-weight: ${theme.typography.weights.normal};
                line-height: ${theme.typography.lineHeight.fourPx};
            `,
            '4_medium': (theme) => `
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.sizes[4]};
                font-weight: ${theme.typography.weights.medium};
                line-height: ${theme.typography.lineHeight.fourPx};
            `,
            '4_bold': (theme) => `
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.sizes[4]};
                font-weight: ${theme.typography.weights.bold};
                line-height: ${theme.typography.lineHeight.fourPx};
            `
        }
    }
}; 